export default __webpack_public_path__ + "static/media/Wall_Door_Center_Orange.256.835af9a9.png";